<template>
  <div class="main">
    <div class="container">
      <div class="header">
        <div class="logo">
          <img src="@/assets/images/logo.png" />
        </div>
        <div class="header-right">
          <div class="add-service">
            <a href="javascript:;">
              <img src="@/assets/images/add_service.png" />
            </a>
          </div>
          <div class="user">
            <a v-if="isLogin" href="https://www.huluer.com/usercenter/">
              <img src="@/assets/images/user2.png" />
            </a>
            <a v-else href="https://www.huluer.com/wp-login.php">
              <img src="@/assets/images/user.png" />
            </a>
          </div>
        </div>
      </div>
      <div class="content-warp">
        <div class="title">
          <img src="@/assets/images/pi_pan.png" />
          <span>派盘</span>
        </div>
        <div class="list">
          <div v-for="(item, index) in serviceList" :key="index" class="item">
            <div class="row">
              <div class="row-left">
                <input
                  v-if="item.id === editId"
                  type="text"
                  v-model="item.name"
                  @blur="save(item)"
                />
                <span v-else class="service-name">{{ item.name }}</span>
                <img class="line" src="@/assets/images/line.png" />
              </div>
              <div class="row-right">
                <!-- 编辑/保存按钮 -->
                <el-tooltip
                  v-if="item.id !== editId"
                  effect="dark"
                  content="编辑"
                  placement="top"
                >
                  <img
                    @click="edit(item.id)"
                    src="@/assets/images/icon_setting.png"
                    class="icon action"
                  />
                </el-tooltip>
                <el-tooltip v-else effect="dark" content="保存" placement="top">
                  <img
                    src="@/assets/images/icon_save.png"
                    class="icon action"
                    @click="save(item)"
                  />
                </el-tooltip>
                <!-- 开关按钮 -->
                <el-tooltip
                  v-if="isWaiting(item.id)"
                  effect="dark"
                  content="请等待"
                  placement="top"
                >
                  <img
                    src="@/assets/images/icon_waiting.gif"
                    class="icon action"
                  />
                </el-tooltip>
                <el-tooltip
                  v-else-if="item.started === 0"
                  effect="dark"
                  content="启动服务"
                  placement="top"
                >
                  <img
                    src="@/assets/images/icon_first.png"
                    class="icon action"
                    @click="startService(item.id)"
                  />
                </el-tooltip>
                <el-tooltip
                  v-else-if="item.started === 1"
                  effect="dark"
                  content="启动服务"
                  placement="top"
                >
                  <img
                    src="@/assets/images/icon_stop.png"
                    class="icon action"
                    @click="resumeService(item.id)"
                  />
                </el-tooltip>
                <el-tooltip
                  v-else-if="item.started === 2"
                  effect="dark"
                  content="暂停服务"
                  placement="top"
                >
                  <img
                    src="@/assets/images/icon_off.png"
                    class="icon action"
                    @click="pauseService(item.id)"
                  />
                </el-tooltip>
                <el-tooltip
                  v-else-if="item.started === 3"
                  effect="dark"
                  content="暂停服务"
                  placement="top"
                >
                  <img
                    src="@/assets/images/icon_on.png"
                    class="icon action"
                    @click="pauseService(item.id)"
                  />
                </el-tooltip>
              </div>
            </div>
            <div class="row">
              <div class="row-left">
                <img src="@/assets/images/icon_star.png" class="icon" />
                <span>远程文件夹</span>
              </div>
              <div class="row-right">
                <span>(</span>
                <a :href="getUrl(item.subdomain)" class="content">
                  <img src="@/assets/images/icon_goto.png" class="icon" />
                  <span>进入</span>
                </a>
                <span>)</span>
              </div>
            </div>
            <div class="row">
              <div class="row-left">
                <img src="@/assets/images/icon_star.png" class="icon" />
                <span>WebDav</span>
              </div>
              <div class="row-right">
                <span>(</span>
                <a :href="getUrl(item.subdomain, 'webdav')" class="content">
                  <img src="@/assets/images/icon_goto.png" class="icon" />
                  <span>进入</span>
                </a>
                <span>)</span>
              </div>
            </div>
            <div class="row">
              <div class="row-left">
                <img src="@/assets/images/icon_star.png" class="icon" />
                <span>硬件加密</span>
              </div>
              <div class="row-right">
                <span>(</span>
                <a :href="getUrl(item.subdomain, 'dongle')" class="content">
                  <img src="@/assets/images/icon_goto.png" class="icon" />
                  <span>进入</span>
                </a>
                <span>)</span>
              </div>
            </div>
            <div class="row">
              <div class="row-left">
                <img src="@/assets/images/icon_star.png" class="icon" />
                <span>镜像备份</span>
              </div>
              <div class="row-right">
                <span>(</span>
                <a :href="getUrl(item.subdomain, 'backup')" class="content">
                  <img src="@/assets/images/icon_goto.png" class="icon" />
                  <span>进入</span>
                </a>
                <span>)</span>
              </div>
            </div>
            <div class="row">
              <div class="row-left">
                <img src="@/assets/images/icon_star.png" class="icon" />
                <span>2020.09.21-2021.09.21</span>
              </div>
              <div class="row-right">
                <span>(</span>
                <a href="javascript:;" class="content">
                  <img src="@/assets/images/icon_goto.png" class="icon" />
                  <span>续费</span>
                </a>
                <span>)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div>
          <img class="fish" src="@/assets/images/gray_fish.png" />
          <img class="fish" src="@/assets/images/gray_fish.png" />
          <img class="fish" src="@/assets/images/blue_fish.png" />
          <img class="fish" src="@/assets/images/gray_fish.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/utils/api.js'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'ServiceList',
  data () {
    return {
      serviceList: null,
      waitingIds: [],
      editId: -1,
      timer: null
    }
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters(['isLogin', 'isPC'])
  },
  async created () {
    this.$store.dispatch('init')
    await this.getServiceList()
  },
  mounted () {
    if (this.timer) {
      clearInterval(this.timer)
    } else {
      this.timer = setInterval(async () => {
        await this.getServiceList()
        console.log(this.serviceList)
      }, 1000 * 20)
    }
  },
  destroyed () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    getUrl (subdomain, type) {
      let url = `https://${subdomain}.huluer.vip/`
      switch (type) {
        case 'webdav':
          url += 'dataSync'
          break
        case 'dongle':
          url += 'dongle'
          break
        case 'backup':
          url += 'backup'
          break
        default:
          break
      }
      return url
    },
    async getServiceList () {
      this.serviceList = await api.getServiceList(this.user.id, this.user.jwt)
    },
    async pauseService (serviceId) {
      if (!this.isLogin) {
        alert('请先登录再进行操作！')
        return
      }
      // 添加到等待列表
      this.waitingIds.push(serviceId)
      try {
        await api.pauseService(this.user.id, this.user.jwt, serviceId)
        await this.getServiceList()
      } catch (error) {
        console.log(error)
      }
      // 从等待列表移除
      const index = this.waitingIds.indexOf(serviceId)
      if (index >= 0) this.waitingIds.splice(index, 1)
    },
    async resumeService (serviceId) {
      if (!this.isLogin) {
        alert('请先登录再进行操作！')
        return
      }
      // 添加到等待列表
      this.waitingIds.push(serviceId)
      try {
        await api.resumeService(this.user.id, this.user.jwt, serviceId)
        await this.getServiceList()
      } catch (error) {
        console.log(error)
      }
      // 从等待列表移除
      const index = this.waitingIds.indexOf(serviceId)
      if (index >= 0) this.waitingIds.splice(index, 1)
    },
    async startService (serviceId) {
      if (!this.isPC) {
        alert('请在PC电脑上进行操作!')
        return
      }
      if (!this.isLogin) {
        alert('请先登录再进行操作！')
        return
      }
      const r = confirm(
        '请确认（1）这是您的个人电脑；（2）本次服务在此电脑部署云化环境并生成远程文件夹。'
      )
      if (r === false) return
      // 添加到等待列表
      this.waitingIds.push(serviceId)
      try {
        await api.startService(this.user.id, this.user.jwt, serviceId)
        await this.getServiceList()
      } catch (error) {
        console.log(error)
      }
      // 从等待列表移除
      const index = this.waitingIds.indexOf(serviceId)
      if (index >= 0) this.waitingIds.splice(index, 1)
    },
    isWaiting (serviceId) {
      return this.waitingIds.some((id) => {
        return id === serviceId
      })
    },
    edit (serviceId) {
      if (!this.isLogin) {
        alert('请先登录再进行操作！')
        return
      }
      this.editId = serviceId
    },
    async save (item) {
      if (!this.isLogin) {
        alert('请先登录再进行操作！')
        return
      }
      if (!item.name) {
        alert('服务名不能为空')
        return
      }
      await api.updateServiceName(
        this.user.id,
        this.user.jwt,
        item.id,
        item.name
      )
      this.editId = -1
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
img {
  height: 100%;
  width: 100%;
}
a {
  text-decoration: none;
  color: #666;
}
.action {
  cursor: pointer;
}
.main {
  font-size: 16px;
  width: 640px;
  height: 590px;
  background: url(./../assets/images/bg.png) no-repeat;
  border: 2px solid #000;
  margin: 0 auto;
  .container {
    width: 540px;
    margin: 0 auto;
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logo {
        width: 276px;
        height: 42px;
      }
      .header-right {
        display: flex;
        font-size: 36px;
        .add-service {
          height: 1em;
          width: 1em;
          margin-right: 1em;
        }
        .user {
          height: 1em;
          width: 1em;
        }
      }
    }
    .content-warp {
      margin-top: 20px;
      max-height: 480px;
      overflow-x: hidden;
      overflow-y: scroll;
      .title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        img {
          width: 48px;
          height: 48px;
          margin-right: 16px;
        }
        span {
          font-size: 22px;
        }
      }
      .list {
        color: #666;
        .item {
          margin-bottom: 20px;
          .row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 5px;
            .icon {
              width: 20px;
              height: 20px;
            }
            .row-left {
              display: flex;
              align-items: center;
              overflow: hidden;
              width: 450px;
              .line {
                height: 1px;
              }
              span {
                white-space: nowrap;
              }
              input {
                border: none;
                background: rgba(52, 149, 238, 0.27);
                border-radius: 4px;
              }
            }
            .row-right {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 80px;
              .content {
                display: flex;
                align-items: center;
              }
            }
          }
          .row:nth-child(1) {
            .row-right {
              justify-content: space-around;
            }
          }
        }
      }
      &::-webkit-scrollbar {
        display: none;
        width: 5px;
        height: 5px;
      }
      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        width: 10px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background: #bbb;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
      }
      &::-webkit-scrollbar-thumb:window-inactive {
        background: #eee;
      }
    }
    .footer {
      display: flex;
      justify-content: center;
      .fish {
        height: 10px;
        width: 24px;
        margin: 0 10px;
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .main {
    width: 320px !important;
    height: 450px !important;
    .container {
      width: 300px !important;
      .header {
        .logo {
          width: 200px;
          height: 31px;
        }
        .header-right {
          font-size: 24px;
          .add-service {
            margin-right: 10px;
          }
        }
      }
      .row-left {
        width: 210px !important;
      }
      .content-warp {
        max-height: 360px !important;
      }
    }
  }
}
</style>
